import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { SocialAsset } from '@contracts/interfaces/socials.interface';

@Injectable({
  providedIn: 'root'
})
export class SocialsService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService) {}

  list() {
    return this.http.post(this.connectionService.address + "/socials-service/list", { });
  }

  create(socialAsset: SocialAsset) {
    return this.http.post(this.connectionService.address + "/socials-service/create", { socialAsset });
  }

  delete(socialAsset: SocialAsset) {
    return this.http.post(this.connectionService.address + "/socials-service/delete", { socialAsset });
  }
}
